function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3F51B5",
  d: "M25,5L6.2,23.8c-1.6,1.6-1.6,4.1,0,5.7l12.3,12.3c1.6,1.6,4.1,1.6,5.7,0L43,23V9c0-2.2-1.8-4-4-4H25z M37,13c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2s2,0.9,2,2C39,12.1,38.1,13,37,13z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF59D",
  d: "M28.2,23.3L27,24.5l-2.7-2.7l-1,1l2.7,2.7l-1.2,1.2L22.2,24c-0.5,0.6-2.4,2.3,0.1,4.8c0.7,0.7,1.4,1.1,1.8,1.3l-1.6,2.2c-0.4-0.2-1.7-1.2-2.3-1.8c-1.8-1.8-3.7-5.5-0.3-8.8l-1.3-1.3l1.2-1.2l1.3,1.3l1-1l-1.3-1.3l1.2-1.2l1.4,1.4c0.9-0.9,4.7-3.7,8.9,0.5c0.7,0.7,1.4,1.7,1.6,2.1l-2.2,1.6c-0.1-0.3-0.5-1-1.2-1.7c-2.3-2.3-4.3-0.5-4.8-0.2L28.2,23.3z"
});

var SvgTariff = function SvgTariff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTariff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tariff.b7f22eb1.svg";
export { ForwardRef as ReactComponent };